import { createAction, props } from '@ngrx/store';
import { TicketEmailSettings } from 'src/app/travelx/models/email-settings.model';

export const loadTicketEmailSettings = createAction('[TICKET EMAIL SETTINGS] Load Ticket Email Settings');
export const loadTicketEmailSettingsSuccess = createAction(
    '[TICKET EMAIL SETTINGS API] Load Ticket Email Settings Success',
    props<{ settings: TicketEmailSettings[] }>()
);
export const loadTicketEmailSettingsFailure = createAction(
    '[TICKET EMAIL SETTINGS API] Load Ticket Email Settings Failure',
    props<{ error: unknown }>()
);
export const updateTicketEmailSettings = createAction(
    '[TICKETS] Update Ticket Email Settings Success',
    props<{ id: number; isSet: boolean }>()
);

export const saveTicketEmailSettings = createAction(
    '[TICKET EMAIL SETTINGS] Save Ticket Email Settings',
    props<{ settings: TicketEmailSettings[] }>()
);
export const saveTicketEmailSettingsSuccess = createAction(
    '[TICKET EMAIL SETTINGS API] Save Ticket Email Settings Successfully',
    props<{ settings: TicketEmailSettings[] }>()
);
export const saveTicketEmailSettingsFailure = createAction(
    '[TICKET EMAIL SETTINGS API] Save Ticket Email Settings Failure',
    props<{ error: unknown }>()
);
